module.exports = __webpack_public_path__ + "img/lazy-load-spinner.667c57b7.gif";